import React from "react";
import { OptInRateChart } from "../components/OptInRateChart";
import { RecentTransactions } from "../components/RecentTransactions";
import DashboardFilters from "../components/DashboardFilters";
import SummaryGrid from "../components/SummaryGrid";
import { useAuth } from "../components/AuthContext";
import { MonthlyRevenueChart } from "../components/MonthlyRevenueChart";
import UserMenu from "../components/UserMenu";
import { showInfo } from "../utils/showToast";
import PageLayout from "../components/PageLayout";

const HomeView: React.FC = () => {
    const { logout, user } = useAuth();

    if (!user) {
        return (
            <div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center">
                <p className="text-sm text-gray-500">Please log in to view the dashboard.</p>
            </div>
        );
    }

    const rightContent = (
        <UserMenu
            username={user.name || "User"}
            email={user.userName || ""}
            id={user.id}
            memberId={user.memberId}
            onLogout={logout}
            onResetPassword={() => showInfo("Reset Password", "Coming soon.")}
        />
    );

    return (
        <PageLayout title="Reporting Dashboard" rightContent={rightContent}>
            <DashboardFilters />
            <SummaryGrid />
            <RecentTransactions />
            <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                <MonthlyRevenueChart />
                <OptInRateChart />
            </div>
        </PageLayout>
    );
};

export { HomeView };
